// export const BASE_URL = 'https://alwalaain-mirror-api.midadworld.com'
export const BASE_URL = 'https://catalog-api.alwalaaingroup.com'
// export const BASE_URL = 'https://alwalaeen-gold-api.alwalaaingroup.com'
// export const BASE_URL = 'https://nahdah-catalog-api.alwalaaingroup.com'
export const BASE_STREAM_URL = BASE_URL + '/api/file-manager/stream/'
